import Flex from "./flex";

export { Flex };
export default {
  Flex,
};
